export enum PaymentMethodsAccepted {
    Visa = 1,
    Mastercard = 2,
    Amex = 4,
    Discover = 8,
    RoomCharge = 16,
    DinersClub = 32,
    JCB = 64,
    GiftCard = 128,
}